import React, { forwardRef } from 'react';

import * as S from './styles';

export type Props = {
  children: React.ReactNode;
  className?: string;
  backgroundColor?: string;
  slug?: string;
  style?: React.CSSProperties;
  id?: string;
};

export const SectionWrapper = forwardRef<HTMLElement, Props>(
  ({ children, backgroundColor, ...rest }, ref) => (
    <S.SectionWrapper ref={ref} $backgroundColor={backgroundColor} {...rest}>
      {children}
    </S.SectionWrapper>
  ),
);

SectionWrapper.displayName = 'SectionWrapper';

export default SectionWrapper;
